const featuresData = [
  {
    icon: 'ri-smartphone-line',
    title: '移动适配',
    desc: '手机端完美适配，随时随地羞羞动漫在线观看，下拉式流畅体验，触屏操作顺滑自然。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '全系列支持羞羞动漫在线高清播放，最高1080P画质，清晰呈现每一帧蜜桃动漫在线细节。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '日更追番',
    desc: '每日准时更新新番资源，蜜桃动漫在线最新剧集48小时内同步上线，不再错过任何精彩。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: '全程无弹窗广告干扰，纯净观看体验，羞羞动漫在线免费观看无需注册，打开即看。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    desc: '收录羞羞动漫在线观看完整版超500部，覆盖校园、奇幻、恋爱等多类蜜桃动漫在线题材。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            本站特色
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            五大核心优势，打造最流畅的羞羞动漫在线观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featuresData.map((item, i) => (
            <div
              key={i}
              className="group p-6 bg-background-100/70 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-800 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}